// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__uDssJ","unreadBadge":"styles_unreadBadge__1s7mz","modalContent":"styles_modalContent__3qWXH","modal":"styles_modal__1ie9e"};